import {
  createRouter,
  createRootRoute,
  createRoute,
  redirect,
} from "@tanstack/react-router";
import { RootLayout } from "./routes/__root";
import { CharCountPage } from "./routes/char-count";
import { LoginPage } from "./routes/login";
import { RegisterPage } from "./routes/register";
import { DashboardPage } from "./routes/dashboard";
import { TextFormatterPage } from "./routes/text-formatter";

const rootRoute = createRootRoute({
  component: RootLayout,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/char-count" });
  },
  component: () => null,
});

const charCountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/char-count",
  component: CharCountPage,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const registerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/register",
  component: RegisterPage,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dashboard",
  component: DashboardPage,
});

const textFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/text-formatter",
  component: TextFormatterPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  charCountRoute,
  textFormatterRoute,
  loginRoute,
  registerRoute,
  dashboardRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
